// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer__Footer___yO2vV","Button":"Footer__Button___1cGoL"};